import { twMerge } from "tailwind-merge";
import { useStoreContext } from "../../contexts/store.context"


export const CategoryFilterItem = ({ category }) => {
    const { selectedCategory, selectCategory, searchTerm, setSearchTerm } = useStoreContext()
    const isActive = (selectedCategory == category) && (searchTerm === undefined)

    const changeCategory = (category) => {
        selectCategory(category.name)
        setSearchTerm(undefined)
    }
    return <div
        className={twMerge(
            'cursor-pointer underline-offset-4 border-l-4 pl-4',
            isActive ? 'border-violet-500 underline' : 'border-transparent',
            'hover:border-white hover:underline'
        )}
        onClick={() => changeCategory(category)}>{category.name}</div>
}

export const CategoryFilter = () => {
    const { categories } = useStoreContext()
    return <div className="flex flex-col gap-8">
        <header className="uppercase font-black">Categories</header>
        <section className="flex flex-col gap-4">
            {categories?.map(category => <CategoryFilterItem key={category.name} category={category} />)}
        </section>
    </div>
}